import React from "react";
import { SearchHit } from "../../../../creditSearch";

export default function Paragraph({ options, items, fontStyle, idx }) {
  const columns = Math.max(1, Number(options?.columns) || 1);
  const columnWidth = Number(options?.column_width) || 100;
  const widthPct = Math.min(100, Math.max(1, columnWidth * columns));
  const textAlign = options?.text_alignment || "center";

  return (
    // Block + margin:auto (not flex justify-center) so html2canvas keeps the
    // blurb horizontally centered after freezePreviewWrapping pins a px width.
    <div className="w-full main-blurb">
      <p
        className="FontSIzeScale"
        style={{
          ...fontStyle,
          display: "block",
          textAlign,
          width: `${widthPct}%`,
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: (fontStyle?.lineHeight ?? 1.1) + 0.2,
          fontKerning: "none",
          fontFeatureSettings: '"kern" 0',
          textRendering: "geometricPrecision",
          WebkitFontSmoothing: "antialiased",
        }}
      >
        {items[0]?.blurb ? <SearchHit text={items[0]?.blurb} /> : " "}
      </p>
    </div>
  );
}
